import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';

import { EventAttendeeRoles } from '../../global.constants';
import { lastNameFirstName, formatUserName } from '../../users/users.utils';

@Component({
  selector: 'app-crew-chip',
  templateUrl: './crew-chip.component.html',
  styleUrls: ['./crew-chip.component.scss'],
  standalone: true,
  imports: [CommonModule, AvatarModule]
})
export class CrewChipComponent implements OnInit {
  @Input() crew: any; // Ideally typed, but 'any' allows flexible inputs from different query fragments
  @Input() displayFormat: 'lastname' | 'fullname' = 'lastname';
  @Input() showIcons = true;

  constructor() { }

  ngOnInit(): void {
  }

  get name(): string {
    const user = this.crew?.user || this.crew;
    if (!user) {
      return '';
    }

    if (this.displayFormat === 'lastname') {
      return lastNameFirstName(user);
    }
    return formatUserName(user);
  }

  get isLead(): boolean {
    return this.crew?.role === EventAttendeeRoles.crewLead || this.crew?.role === EventAttendeeRoles.assistantCrewLead;
  }

  get isDriver(): boolean {
    return this.crew?.role === EventAttendeeRoles.driver || this.crew?.isDriver;
  }
}
